import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Figure as FigureComponent, FigureImage, FigureListContainer, PositionLabel } from "./FigureList.styles";
export var FigureList = function(param) {
    var content = param.content, positionLabel = param.positionLabel;
    return /*#__PURE__*/ _jsx(FigureListContainer, {
        contentLength: content.length,
        children: content.map(function(param) {
            var position = param.position, src = param.src;
            return /*#__PURE__*/ _jsxs(FigureComponent, {
                children: [
                    /*#__PURE__*/ _jsx(FigureImage, {
                        src: src,
                        alt: "Provider Logo"
                    }),
                    /*#__PURE__*/ _jsxs(PositionLabel, {
                        textColor: "current",
                        children: [
                            position,
                            ". ",
                            positionLabel
                        ]
                    })
                ]
            }, position);
        })
    });
};
